import {$document,$window,$htmlBody,$html,$body,$main,$footer} from './Variables';
import {show,hide,tweenX,tweenY} from './Toggle.js';

const scrollTo = (element,target,options) => {
  $(element).on('click',function(){
    TweenLite.to(
      window,
      1,
      {scrollTo:
        {y: target, offsetY: 0, autoKill: false,},
        ease: options.ease,
      }
    );
  });
};

const getScrollBottom = () => {
  const body = window.document.body;
  const html = window.document.documentElement;
  const scrollTop = body.scrollTop || html.scrollTop;
  return html.scrollHeight - html.clientHeight - scrollTop;
};

class SmoothScroll {
  constructor(element,target,options) {
    this.element = element;
    this.target   = target;
    this.options  = options;
  }
  /**
   * [scroll description]
   * @return {[type]} [description]
   */
  setScroll() {
    const target = this.target,
    options = this.options;

    scrollTo(this.element,target,options);
  }
  toggle() {
    const target = this.target,
    options = this.options;

    tweenY(this.element,options);
  }
}

export {scrollTo,getScrollBottom,SmoothScroll}